var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
	var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	var detail = {
	  detail: data
	};
	var event = new CustomEvent(eventName, data ? detail : null);
	document.dispatchEvent(event);
  };
  
document.addEventListener("DOMContentLoaded", () => {
  const CartDrawer = document.getElementById('Cart-Drawer');
  // const CartDrawerForm = document.getElementById('CartDrawerForm');

  if(!CartDrawer) return;

  // if(!CartDrawer) {
  //   console.log("CART DRAWER ERROR!!!");
  // }

  CartDrawer.addEventListener('change', (event) => {
    //event.preventDefault();
    if(!event.target.classList.contains('product-cart-item-option-select')) return;

    document.body.classList.add('loader-is-active');

    let cartInfo = event.target.closest('.product-cart-item-info');
    let container = event.target.closest('.product-cart-item-options.cart-variant');
    let productVariantSelect = container.querySelector('[name="id"]');
    let props = {};

    //STORE LINE ITEM PROPERTIES TO AN OBJECT
    cartInfo.querySelectorAll('.cart-item-property').forEach(property => {
      props = {
        [property.querySelector('.property-name').dataset.name]: property.querySelector('.property-value').dataset.value
      }
    });
    Object.assign(props,{["_position"]: event.target.closest('.product-cart-item').querySelector('[name="properties[_position]"]').value});
    //console.log(props);

    //GET SELECTED VALUES FROM ATTRIBUTES AND SELECTS
    let currentData = {
      key: cartInfo.querySelector('quantity-selector.quantity').dataset.id,
      id: productVariantSelect.dataset.id,
      index: productVariantSelect.dataset.index,
      value: productVariantSelect.value,
      qty: 0,
      properties: props
    };

    //console.log("OLDDATA_____________________________________________________________________________________");
    //console.log(currentData);

    // UPDATE SELECTS TO NEWLY SELECTED VALUES
    updateSelectedAttributes(container, '.product-cart-item-option-select');
    updateSelectedAttributes(container, '[name="id"]');
    //updateVariantSelect(options, productVariantSelect);

    let newData = {
      id: productVariantSelect.dataset.id,
      value: productVariantSelect.getAttribute('title'),
      qty: cartInfo.querySelector('[name="updates[]"]').value,
      properties: props
    };

    //console.log("NEWDATA_____________________________________________________________________________________");
    //console.log(newData);

    //ADD THE NEW ITEM. THE UPDATING OF ITEM IS DONE INSIDE THE ADDNEWITEM FUNCTION
    addNewItem(newData.id, newData.qty, currentData.key, currentData.qty, container, props);

    //REFRESH THE CART'S UI
    //dispatchCustomEvent('cart:refresh');
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));

  });


  function updateSelectedAttributes(container, selector, props) {
    if(selector === '.product-cart-item-option-select') {
      try {
        let selects = Array.from(container.querySelectorAll('.product-cart-item-option-select'));
        container.querySelector('.product-cart-item-option-select option[selected]').removeAttribute("selected");
        selects.forEach((select) => {
          select.options[select.selectedIndex].setAttribute("selected","");
          select.dataset.title = select.value.trim();
          select.previousElementSibling.textContent = select.value.trim();
        });
      }
      catch(err) {
        console.log(`ERROR UPDATING SELECTED OPTION: ${err}`);
      }
    }

    if(selector === '[name="id"]') {
      try {
        let newVariantArray = getOptions(container);
        let newVariant = newVariantArray.join(' / ');
        //alert(newVariant);
        let select = container.querySelector('[name="id"]');
        select.querySelector('[selected]').removeAttribute("selected");
        select.querySelector(`[value="${newVariant.trim()}"]`).setAttribute("selected","");
        select.dataset.id = select.querySelector(`option[value="${newVariant}"]`).getAttribute('data-id');
        select.setAttribute("title", select.querySelector(`option[value="${newVariant}"]`).getAttribute('value'));
      }
      catch(err) {
        console.log(`ERROR UPDATING SELECTED VARIANT: ${err}`);
      }
    }
    if(selector === '.product-cart-item-property') {
      let properties = props;
      //console.log(properties);
      try {
        if(selector.childElementCount > 0) {
          selector.children.forEach((property) => {
            Object.keys(properties).forEach(key => {
              property.querySelectorAll('.property-name').textContent = key;
              property.querySelector('.property-name').dataset.name = key;
            });
            Object.values(properties).forEach(value => {
              property.querySelector('.property-value').textContent = value;
              property.querySelector('.property-value').dataset.value = value;
            });
          });
        } else if(Object.entries(properties).length > 0) {
          Object.entries(properties).forEach(entry => {
            let p = document.createElement("p").classList.add('cart-item-property');

            let n = document.createElement("span").classList.add('property-name').setAttribute("data-name", entry[0]);
            n.textContent = entry[0] + ": ";
            p.appendChild(n);

            let v = document.createElement("span").classList.add('property-value').setAttribute("data-name", entry[1]);
            v.textContent = entry[1];
            p.appendChild(v);

            selector.querySelector('.product-cart-item-properties').appendChild(p);
          });
        }
      } catch(err) {
        console.log(`ERROR UPDATING ITEM PROPERTIES: ${err}`);
      }
    }
  }

  function getOptions(container) {
    let options = [];
    var singleOptions = Array.from(container.querySelectorAll('.product-cart-item-option-select'));
    singleOptions.forEach(opt => {
      if(opt.value) {
        options.push(opt.value.trim());
        //opt.previousElementSibling.textContent = opt.value.trim();
      }
    });
    return options;
  }

  async function addNewItem(id, qty, currKey, currQTY, container, props) {
    await fetch(theme.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: id,
        quantity: parseInt(qty),
        properties: props,
        sections: 'cart-drawer',
        sections_url: window.location.pathname
      })
    })
    .then(data => {
      //const parsedState = JSON.parse(data);
      updateVariantInCart(currKey, currQTY);

      dispatchCustomEvent('line-item:change:end', {
        quantity: parseInt(qty),
        cart: data
      });

      dispatchCustomEvent('cart:item-added', {
        cart: data
      });

      //updateSelectedAttributes(container, '.product-cart-item-property', props);
      // document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      //   bubbles: true
      // }));
    })
    .catch((e) => {
      console.error('Error:', e);
      document.body.classList.remove('loader-is-active');
    });
  }


  async function updateVariantInCart(key, quantity) {
    await fetch(theme.routes.cart_change_url, {
      method: "POST",
      headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
      },
      body: JSON.stringify({
          id: key,
          quantity: parseInt(quantity)
      })
    })
    .then(data => {

      dispatchCustomEvent('line-item:change:end', {
        quantity: parseInt(quantity),
        cart: data
      });

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));

      setTimeout(() => {
        document.body.classList.remove('loader-is-active');
      }, 500);
    })
    .catch((e) => {
      console.error('Error:', e);
      document.body.classList.remove('loader-is-active');
      //loader.style.display = 'none';
    });
    //return response.json();
  }


	//CART DRAWER CUSTOM CONTAINER
	let cartDrawerContainer = document.getElementById('CartDrawerContainer');
	if(cartDrawerContainer) {
	  const cartDrawerTrigger = document.getElementById('cart-drawer-toggle');
	  cartDrawerTrigger.addEventListener('click', () => {
		//let cartDrawerContainer = document.querySelector('#CartDrawerContainer.custom-cart-container, #CartDrawerContainer.custom-cart-container *');
		document.body.classList.add('open-cc');
		cartDrawerContainer.classList.add('active');
		dispatchCustomEvent('cart-drawer:open');
	  });
	}
	
	//let closeSelectors = ['.custom-cart-container .side-panel-close','.click-capture'];
	let closeSelectors = ['.cart-drawer-free-shipping-bar-form .side-panel-close','.cart-drawer-side-panel-close','.click-capture'];
	closeSelectors.forEach(selector => {
	  if(!document.querySelector(selector.toString())) return;
	  document.querySelector(selector.toString()).addEventListener('click', (evt) => {
		if(cartDrawerContainer.classList.contains('active')) {
		  document.body.classList.remove('open-cc');
		  cartDrawerContainer.classList.remove('active');
		}
	  });
	});
});

document.addEventListener("DOMContentLoaded", () => {
  if(document.querySelectorAll('custom-collapsible')) {
    const collapsibleArray = document.querySelectorAll('custom-collapsible');
    collapsibleArray.forEach((collapsible) => {

      if(!this.querySelectorAll('.trigger')) return;
      let collapsibleItemsArray = this.querySelectorAll('.trigger');
      collapsibleItemsArray.forEach((item) => {

        collapsible.addEventListener("click", function() {

          this.classList.toggle("active");
          let content = this.nextElementSibling;
          if (content.style.maxHeight){
            content.style.maxHeight = null;
          } else {
            content.style.maxHeight = content.scrollHeight + "px";
          }
        });

      });

    });
  }
});





